import { Dealer } from '@upstart/harmony/lib/legos/dealerTypes';
import { TradeIn } from '@upstart/harmony/lib/legos/dealTypes';
import { COUNTRIES } from '@upstart/harmony/lib/constants';
import BackendService from './BackendService';

export interface IdNamePair {
  id: number;
  name: string;
}

export default class KbbService {
  static getTMV(dealer: Dealer, tradeIn: TradeIn) {
    const isCanada = dealer?.country === COUNTRIES.CA;
    const zip = tradeIn.zip || dealer?.zip;
    const mileage = tradeIn.mileage;
    const trim = tradeIn.trim?.id;
    const vehicleOptionIds = tradeIn.vehicleOptionIds;
    let locationId;

    if (isCanada) {
      locationId = dealer?.zip;
    }

    const params = {
      ...(zip && { zip }),
      ...(locationId && { locationId }),
      mileage,
    };

    return BackendService.post(`/kbb/tmvWithVehicleOptions/${trim}`, {
      params,
      body: {
        vehicleOptionIds,
      },
    });
  }

  static getYears(): Promise<IdNamePair[]> {
    return BackendService.get('/kbb/years');
  }

  static getMakes(year: string): Promise<IdNamePair[]> {
    return BackendService.get(`/kbb/makes/${year}`);
  }

  static getModels(year: string, make: string): Promise<IdNamePair[]> {
    return BackendService.get(`/kbb/models/${year}/${make}`);
  }

  static getTrims(
    year: string,
    make: string,
    model: string,
  ): Promise<IdNamePair[]> {
    return BackendService.get(`/kbb/trims/${year}/${make}/${model}`);
  }
}
